var map = {
	"./feature-confirm-details.svg": 8772,
	"./feature-consumer-protection.svg": 9193,
	"./feature-order-confirmed.svg": 2272,
	"./feature-order-pending.svg": 8836,
	"./feature-order-unsuccessful.svg": 9889,
	"./feature-verify-info.svg": 2884,
	"./spotrisk-logo-blue.svg": 4846,
	"./spotrisk-logo-full-white.svg": 9325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1061;